import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Image from "react-bootstrap/Image";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import { ReadMore } from "../../components/ReadMore";
// import "../../css/PublicationsCSS.css";
// import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useEffect } from "react";

// const publicationsFile: string = "publications.json";

// If we import the JSON file, then it is loaded as soon this file is imported (On server enable)
// import publicationsJSON from "./publications.json";

interface Publication {
  title: string;
  date: string;
  type: string;
  abstract: string;
  link: string;
  image: string;
  "sjr-id": string | null;
}

//Use state calls this function
export const Publications = () => {
  useEffect(() => {
    document.title = "PARSO - Publications";
  }, []);

  const publicationsJSON = require("./publications.json");
  const publicationList: Publication[] = publicationsJSON.publications;

  const isMobile = window.innerWidth < 768;

  return (
    <>
      {/* Container is not exactly necessary, but it is better for organized spacing */}
      <Container style={{
        marginTop: "30px",
        marginBottom: "100px",
        maxWidth: "1600px",
      }}>
      <h3 style={{ textAlign: "center", fontWeight: "600", fontSize: "2.5rem" }}>
        Publications{" "}
        <span style={{ color: "gray" }}>({publicationList.length})</span>
      </h3>

        <div style={{
              borderColor: "rgba(0, 0, 0, 0.3)",
              borderRadius: "20px",
              borderStyle: "solid",
              padding: "10px",
              marginTop: "30px"
        }}>
          {publicationList.map((publication) => (
            // <Row>
            //mx-auto means margin x auto. This is a feature in bootstrap
            // className="my-5" -> Means margin y is set to 5
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1.5 }}
              // viewport={{ once: true }}
            >
              {renderPublicationCard(publication, isMobile)}
            </motion.div>
            // </Row>
          ))}
        </div>
      </Container>
    </>
  );
};

const renderPublicationCard = (publication: Publication, isMobile: boolean) => (
              <Card>
                <Card.Header>{publication.type}</Card.Header>
                <Card.Body>
                  <Container fluid>
                    <Row>


                      <Col
                        xs={{ span: 12, order: 0 }}
                        lg={{ span: 6, order: 0 }}
                      >
                        <Card.Title className="justify-text bold">
                          {publication.title}
                        </Card.Title>
                        <Card.Subtitle className="mb-2 text-muted">
                          {publication.date}
                        </Card.Subtitle>
                        <Card.Text className="justify-text">
                          <ReadMore charlimit={isMobile ? 500 : 1200}>
                            {"Abstract: " + publication.abstract}
                          </ReadMore>
                          {/* Article is in-progress. Please check back later for the abstract and link to the publication. */}
                        </Card.Text>
                      </Col>



                      <Col
                      // class="col-5"
                      >
                        {/* You make the row 'relative' so that whatever uses absolute position is relative to this row */}
                        <Row style={{ position: "relative" }}>
                          {publication.image != undefined ? (
                            <Image
                              src={publication.image}
                              fluid
                              className="my-2"
                            />
                          ) : null}
                          {/* {publication["sjr-id"] != undefined ? (
                            <a
                              href={
                                "https://www.scimagojr.com/journalsearch.php?q=" +
                                publication["sjr-id"] +
                                "&tip=sid&exact=no"
                              }
                            >
                              <Image
                                src={
                                  "https://www.scimagojr.com/journal_img.php?id=" +
                                  publication["sjr-id"]
                                }
                                style={{
                                  width: "25%",
                                  // height: "40%",
                                  position: "absolute",
                                  top: "2%",
                                  right: "2%",
                                }}
                              />
                            </a>
                          ) : null} */}
                        </Row>

                        <Row>
                          <Col className="text-center">
                <Button
                  variant={publication.link != null ? "primary" : "secondary"}
                  href={publication.link}
                  className="my-4"
                  style={{
                    padding: "12px 20px",
                    fontSize: "1rem",
                    fontWeight: "bold",
                    borderRadius: "30px",
                    transition: "background-color 0.3s ease, transform 0.3s ease",
                  }}
                >
                  {publication.link != null ? "View publication" : "Pending publication"}
                </Button>
                          </Col>
                        </Row>
                      </Col>


                    </Row>
                  </Container>
                </Card.Body>
              </Card>
)